import { useTranslations } from "use-intl";
import { IncidentStatus } from "@/gql/graphql";
import { WarningBanner } from "@/lib/Components/Banners/WarningBanner";
import { useIncidentRecord } from "@/app/Incidents/Hooks/useIncidentRecord";
import { useCanEditIncident } from "@/app/Incidents/Hooks/useCanEditIncident";
import { IncidentPhotosCard } from "@/app/Incidents/Components/Details/IncidentPhotosCard";
import { IncidentReportCard } from "@/app/Incidents/Components/Details/IncidentReportCard";
import { IncidentClaimCard } from "@/app/Incidents/Components/Details/IncidentClaimCard";
import { IncidentJobCard } from "@/app/Incidents/Components/Details/IncidentJobCard";

export function IncidentDetailsScreen() {
  const t = useTranslations("incident.details");
  const incident = useIncidentRecord();
  const canEdit = useCanEditIncident(incident);

  return (
    <div className="space-y-10 py-6">
      {canEdit ? null : (
        <WarningBanner>
          {incident.status === IncidentStatus.Closed
            ? t("lockedClosed")
            : t("lockedClaimOpen")}
        </WarningBanner>
      )}
      <IncidentReportCard incident={incident} />
      <IncidentClaimCard incident={incident} />
      <IncidentPhotosCard incident={incident} />
      <IncidentJobCard incident={incident} />
    </div>
  );
}
